import { render, staticRenderFns } from "./post-loading.vue?vue&type=template&id=1e45d972&scoped=true"
import script from "./post-loading.vue?vue&type=script&lang=js"
export * from "./post-loading.vue?vue&type=script&lang=js"
import style0 from "./post-loading.vue?vue&type=style&index=0&id=1e45d972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45d972",
  null
  
)

export default component.exports